import React from 'react'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axios  from 'axios';
import {useLocation} from 'react-router-dom';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import baseUrl from '../../../services/api';
import Button from 'react-bootstrap/Button';
import { useNavigate} from "react-router-dom";
import './style.css'
const UserComponents = ({customers,userEmail}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [user, setUser] = React.useState(null);
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [role, setRole] = React.useState("");




  const handleClickOpen = (customer) => {
    console.log(customer);
    setUser(customer)
    setFirstName(customer.firstName)
    setLastName(customer.lastName)
    setRole(customer.RoleAdmin?"admin":"user")

    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleDelete = () => {

    setOpen(false);
    try{
      var deletey = sessionStorage.getItem('email');
      axios
      .delete(`${baseUrl}/deleteUser/${deletey}/admin/${user.email}`)
      
      .then((response) => 
      {
      alert(response.data.message)
      window.location.reload(false);
    
    }
      )    
      .catch(err => {
        console.error(err);
        
      }); 
    } catch (error) {
      if(error.message === 'Network Error'){
          alert('no internet connection');
      }
  }

  };

  return (

      <div className="p-3" style={{color:'black'}}>

        {/* Table */}
        <div className="table">
          <Table className="table-auto w-full">
            {/* Table header */}
            <Thead className="text-xs font-semibold uppercase text-slate-400 bg-slate-50">
              <Tr>
                <Th className="p-2 whitespace-nowrap">
                  <div className="font-semibold text-left">Name </div>
                </Th>
                <Th className="p-2 whitespace-nowrap">
                  <div className="font-semibold text-left">Email</div>
                </Th>
                <Th className="p-2 whitespace-nowrap">
                  <div className="font-semibold text-left">Status</div>
                </Th>
    
              </Tr>
            </Thead>
            {/* Table body */}
            <Tbody className="text-sm divide-y divide-slate-100">
              {
                customers.map(customer => {
                  return (
                    <Tr key={customer.email} style={{color:'black'}}>
                      <Td className="p-2 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="w-10 h-10 shrink-0 mr-2 sm:mr-3">
          
                          </div>
                          <div className="font-medium text-slate-800">{`${customer.firstname}   ${customer.lastname}`}</div>
                        </div>
                      </Td>
                      <Td className="p-2 whitespace-nowrap">
                        <div className="text-left">{customer.email}</div>
                      </Td>
                      <Td className="p-2 whitespace-nowrap">
                        
                        <Button variant="outline-danger" onClick={()=>handleClickOpen(customer)} style={{padding:'5px'}}>Delete</Button>
                      </Td>

                    </Tr>
                  )
                })
              }
            </Tbody>
          </Table>

        </div>
       <Dialog
        open={open}
      
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
            >
        <DialogTitle id="alert-dialog-title">
          {`Do you want to Delete ${role} ${firstName}  ${lastName}`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
           {`If you delete this ${role}  you can not undo the operation`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="secondary" onClick={handleClose}>Cancle</Button>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      </div>

  )
}

export default UserComponents